<template>
  <div style="width:100%;background-color:#F2F2F2">
    <!--顶部info-->
    <div class="headInfo">
      <div class="inputBox">
        <!--input-->
        <div class="inputstyle">
          <input v-model="shopGoods" placeholder="搜索店铺内的宝贝" />
          <img v-if="shopGoods.length>0" src="../assets/images/images/closeTC.png" class="closeTc" @click="searchAll"/>
        </div>
        <div class="searchBox" @click="searchGoodsByKeywords">
          <img src="../assets/images/images/search.png" />
        </div>
      </div>
      <!--shopBasicInfo-->
      <div class="shopBasicInfo">
        <div class="shopBasicInfoLeft">
          <div>
            <div class="headImg">
              <img :src="shopInfo.small_logo_url" />
            </div>
            <div class="shopName">
              <div style="width: 75px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">{{shopInfo.name}}</div>
              <div class="eCard">
                <img @click="showEcard" src="../assets/images/images/eCard.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="shopBasicInfoRight">
          <div v-if="!hasGuanzhu" class="attaBox" @click="guanzhuShop">
            <div class="attaImg">
              <img src="../assets/images/images/save.png" />
            </div>
            <div>关注</div>
          </div>
          <div v-else class="attaBox" @click="removeGuanzhu">
            <div class="attaImg">
              <img src="../assets/images/images/save.png" />
            </div>
            <div>取消关注</div>
          </div>
        </div>
      </div>
    </div>
    <!--选择-->
    <div class="chooseBtn">
      <div @click="showAG" :class="showAllGoods?'active':'noactive'">全部商品</div>
      <div @click="showSI" :class="showShop?'active':'noactive'">商家信息</div>
    </div>
    <!--1.店铺全部宝贝信息-->
    <div v-if="showAllGoods" class="goodsContent">
      <!--左侧列表-->
      <div class="contentLeft">
        <div
          @click="searchGoodsByCategory(0)"
          :class="nowCategoryId=='0'?'activeList':'noactiveList'"
        >全部</div>
        <div
          v-for="(item,index) in shopCategoryList"
          :key="index"
          @click="searchGoodsByCategory(item.id)"
          :class="nowCategoryId==item.id?'activeList':'noactiveList'"
        >{{item.name}}</div>
      </div>
      <!--右侧内容-->
      <div class="contentRight">
        <div @click="showOnlyOne(index)" v-for="(item,index) in goodsList" :key="index">
          <goodsTemplate :urls="item.thumbs" :content="item.content"></goodsTemplate>
        </div>
      </div>
    </div>

    <!--2.单个宝贝信息-->
    <div v-if="showOneGoods">
      <!--收藏宝贝-->
      <div class="saveGoods">
        <div></div>
        <div>
          <div v-if="shopInfo.phone" class="phoneCall">
            <a :href="'tel:'+shopInfo.phone">
              <img src="../assets/images/images/tel_1.gif" />
            </a>
          </div>
          <div v-else class="phoneCall">
            <img src="../assets/images/images/noPhone.png" alt />
          </div>

          <div class="saveGood">
            <div>
              <img style="width:100%;height:100%;" src="../assets/images/images/loveGoods.png" />
            </div>
            <div v-if="!hasSaveGood" @click="saveGoods">收藏宝贝</div>
            <div v-else @click="removeSave">取消收藏</div>
          </div>
        </div>
      </div>
      <!--详细信息-->
      <div class="detailInfoContent">
        <div class="goodsDetailInfo">{{nowOneGood.content}}</div>
        <div class="goodsImages">
          <div v-for="(item,index) in nowOneGood.thumbs" :key="index" @click="previewPic2(index)">
            <img :src="item.small_path_url" />
          </div>
          <div
            v-if="showClose"
            style="position:fixed;bottom:0px;left:0px;width:100%;display:flex;justify-content: center;z-index:9999"
          >
            <img
              @click="closeImg"
              style="width:30px;height:30px;"
              src="../assets/images/images/close.png"
              alt
            />
          </div>
        </div>
      </div>
      <!--宝贝推荐-->
      <div class="goodsRecom">宝贝推荐</div>
      <div class="recomdeList">
        <div @click="showOnlyOne2(index)" v-for="(item,index) in recommendGoodsList" :key="index">
          <goodsTemplate :urls="item.thumbs" :content="item.content"></goodsTemplate>
        </div>
      </div>
    </div>
    <!--3.店铺信息-->
    <div v-if="showShop">
      <div class="basicInfo">
        <div>
          <div>联系人</div>
          <div>{{shopInfo.contact}}</div>
        </div>
        <div>
          <div>联系电话</div>
          <div>{{shopInfo.mobile}}</div>
        </div>
        <div>
          <div>联系QQ</div>
          <div>{{shopInfo.qq}}</div>
        </div>
        <div>
          <div>地址</div>
          <div>{{shopInfo.address}}</div>
        </div>
        <div>
          <div>主营信息</div>
          <div>{{shopInfo.business}}</div>
        </div>
      </div>
      <!--商家二维码-->
      <div class="shopCode" @click="previewPic3">商家二维码</div>
      <!--商家简介-->
      <div class="simpleInfo">
        <div>商家简介</div>
        <div>{{shopInfo.intro}}</div>
      </div>
      <!--商家照片-->
      <div class="shopImages">
        <div>商家照片</div>
        <div class="shopImg">
          <div v-for="(item,index) in smallImages" @click="previewPic(index)" :key="index">
            <img :src="item" />
          </div>
        </div>
        <div
          v-if="showClose"
          style="position:fixed;bottom:50px;left:0px;width:100%;display:flex;justify-content: center;z-index:9999"
        >
          <img
            @click="closeImg"
            style="width:30px;height:30px;"
            src="../assets/images/images/close.png"
            alt
          />
        </div>
      </div>
      <!--商家动态-->
      <div class="shopAct">
        <div>商家动态</div>
        <div class="actItem" v-for="(item,index) in actArray" :key="index">
          <div>【{{item.category.title}}】{{item.content}}</div>
          <div>
            <div>更新:{{item.published_time}}</div>
            <div class="btmImage">
              <div v-for="(item2,index2) in item.thumbs" v-if="index2<=2" :key="index2">
                <img  :src="item2.small_path_url" @click="prepareShowImg(item.thumbs,index2)" />
              </div>
            </div>
            <div @click="showError(item.id)">纠错/举报</div>
          </div>
        </div>
      </div>
    </div>
    <div style="height:100px;width:100%;"></div>
    <div
      style="height:100%;width:100%;position:fixed;left:0;top:0;z-index:-1;background-color:#F2F2F2"
    ></div>
    <!--展示海报-->
    <div class="bg" v-if="showhaibao"></div>
    <div class="haibao" v-if="showhaibao">
      <img :src="lastUrl" />
      <div class="saveHB" v-if="showhaibao" @click="closeHb">关闭海报</div>
    </div>

    <!--保存海报-->
    <div class="haibao2" ref="imageWrapper" id="imageWrapper" v-if="showCard">
      <div class="hbheadImg">
        <img src="../assets/images/images/topInfoImg.png" />
      </div>
      <!--海报模块-->
      <div style="margin: -30px 30px 10px;">
        <div class="hbShopInfo">
          <img ref="headddImage" id="headddImage" src />
        </div>
        <div class="shopNames">{{shopInfo.name}}</div>
      </div>
      <div style="display: flex;justify-content: center;margin-bottom: 10px;">
        <img style="width: 80%;height: 1px;" src="../assets/images/images/dotta.png" />
      </div>
      <!--信息模块-->
      <div class="infoBack">
        <div class="infoItem">
          <div>
            <img src="../assets/images/images/hbUser.png" />
          </div>
          <div>{{shopInfo.contact}}</div>
        </div>
        <div class="infoItem">
          <div>
            <img src="../assets/images/images/hbPhone.png" />
          </div>
          <div>{{shopInfo.phone}}</div>
        </div>
        <div class="infoItem">
          <div>
            <img src="../assets/images/images/hbQQ.png" />
          </div>
          <div>{{shopInfo.qq}}</div>
        </div>
        <div class="infoItem">
          <div>
            <img src="../assets/images/images/hbdw.png" />
          </div>
          <div>{{shopInfo.address.length>12?shopInfo.address.substr(0,12)+'...':shopInfo.address}}</div>
        </div>
      </div>
      <!--主营-->
      <div class="baseSale">
        <div>主营</div>
        <div>{{shopInfo.business.length>15?shopInfo.business.substr(0,15)+'...':shopInfo.business}}</div>
      </div>
      <div style="display:flex;justify-content:center;">
        <Qrcode :text="codeText" :swidth="swidth"></Qrcode>
      </div>
      <!--底部信息-->
      <div class="bottom">
        <div>长按识别此二维码</div>
        <div>进入我的企业中心</div>
      </div>
      <div class="hbheadImg" style="position:absolute;bottom:0;">
        <img src="../assets/images/images/bottomInfo.png" />
      </div>
    </div>
    <template v-if="actions.length">
      <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
    </template>
    <!-- <HomeTab></HomeTab> -->
    <BackTop></BackTop>
  </div>
</template>
<script>
let me;
let instance;
import { ImagePreview } from "vant";
import HomeTab from "../components/HomeTab2";
import goodsTemplate from "../components/goodsTemplate";
import Qrcode from "../components/qrcode.vue";
import { getData } from "../Interface/http.js";
import { postData } from "../Interface/http.js";
import BackTop from "@/components/BackTop.vue";
import html2canvas from "html2canvas";
export default {
  name: "shopDetailInfo",
  data() {
    return {
      showhaibao: false,
      lastUrl: "", //最终图片地址
      codeText: "",
      showCard: false, //是否展示电子卡
      showClose: false,
      hasSaveGood: false, //是否收藏宝贝
      hasGuanzhu: false, //判断用户是否关注
      shopGoods: "", //店铺商品
      shopId: "",
      showAllGoods: false, //是否展示所有商品信息
      showOneGoods: false, //是否展示单个商品信息
      showShop: true, //是否展示店铺信息
      shopInfo: {}, //店铺信息
      shopCategoryList: [], //店铺商品分类列表
      nowCategoryId: 0, //当前分类id
      goodsList: [], //商品列表
      nowOneGood: {}, //当前商品
      recommendGoodsList: [], //推荐商品列表
      images: [], //商家信息照片列表
      smallImages: [], //
      preImgages: [], //宝贝详情页预览图片列表
      type: "", //跳转类型
      actArray: [], //动态列表
      show: false,
      tipId:""
    };
  },
  components: {
    HomeTab,
    goodsTemplate,
    BackTop,
    Qrcode,
  },
  computed: {
    actions() {
      let arr = [];
      if (this.$store.state.nowActions !== "[]") {
        arr = this.$store.state.nowActions;
      } else {
        arr = JSON.parse(sessionStorage.getItem("nowActions"));
      }
      let arr1 = [];
      if (arr.length != 0) {
        for (let a = 0; a < arr.length; a++) {
          let id = arr[a].id;
          let name = arr[a].title;
          arr1.push({ id: id, name: name });
        }
      }
      return arr1;
    },
    swidth() {
      return (window.innerWidth * 0.9 * 0.4 * 320) / window.innerWidth / 20; //370*320/(window.innerWidth)/20
    },
  },
  methods: {
    searchAll() {
      this.shopGoods = '';
      this.nowCategoryId = 0;
      this.searchGoodsByCategory(0);
    },
      showError(id){
          me.show=true;
          me.tipId=id;
      },
    onSelect(item) {
      let param = {
        message_id: me.tipId,
        option_id: item.id,
      };

      postData("/report", param)
        .then((res) => {
          this.show = false;
          this.$toast("纠错成功");
        })
        .catch((err) => {
          this.show = false;
          this.$toast("纠错失败,请加客服对接!");
        });
    },
    /**获取商家动态信息 */
    getshopAct() {
      getData("/shop/recent-messages", {
        shop_id: me.shopId,
        num: 100
      }).then((res) => {
        me.actArray = res.data;
      });
    },
    closeHb() {
      me.showhaibao = false;
    },
    getBase64Image(url) {
      var that = this;
      var image = new Image();
      image.crossOrigin = "*"; // 支持跨域图片
      image.src = url + "?v=" + Math.random(); // 处理缓存
      image.onload = function () {
        var base64 = that.drawBase64Image(image);
        that.$refs["headddImage"].src = base64;
        me.toSave();
      };
    },
    drawBase64Image(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.width, img.height);
      var dataURL = canvas.toDataURL("image/png");
      return dataURL;
    },
    //点击保存
    toSave() {
      html2canvas(document.querySelector("#imageWrapper"), {
        useCORS: true,
      }).then((canvas) => {
        let saveUrl = canvas.toDataURL("image/png");
        me.lastUrl = saveUrl;
      });
    },
    //展示电子卡
    showEcard() {
      me.showhaibao = true;
    },
    closeImg() {
      this.showClose = false;
      if (instance) {
        instance.close();
      }
    },
    //预览图片
    previewPic(index) {
      this.showClose = true;
      instance = ImagePreview({
        images: this.images,
        asyncClose: true,
        startPosition: index,
      });
    },
    //预览图片
    previewPic2(index) {
      this.showClose = true;
      instance = ImagePreview({
        images: this.preImgages,
        asyncClose: true,
        startPosition: index,
      });
    },
    //预览帖子
    prepareShowImg(array, index) {
      this.showClose = true;
      instance = ImagePreview({
        images: array.map((item) => {
          return item.path_url;
        }),
        asyncClose: true,
        startPosition: index,
      });
    },
    //预览图片
    previewPic3(index) {
      if (me.shopInfo.weixin_url) {
        this.showClose = true;
        instance = ImagePreview({
          images: [me.shopInfo.weixin_url],
          asyncClose: true,
        });
      } else {
        this.$toast("暂无二维码");
      }
    },
    showAG() {
      me.type = "goods";
      me.showShop = false;
      me.showAllGoods = true;
      me.showOneGoods = false;
      me.searchGoodsByCategory(0);
      me.getShare(); //xhy:05.24
    },
    showSI() {
      me.type = "info";
      me.showShop = true;
      me.showAllGoods = false;
      me.showOneGoods = false;
      me.getShare(); //xhy:05.24
    },
    showOnlyOne(index) {
      //右侧进入单个商品页面
      me.showShop = false;
      me.showAllGoods = false;
      me.showOneGoods = true;
      me.nowOneGood = me.goodsList[index];
      me.preImgages = me.nowOneGood.thumbs.map((item) => {
        return item.path_url;
      });
      me.searchUserHasSaveGoods(me.nowOneGood.id);
    },
    showOnlyOne2(index) {
      //推荐列表进入单商品页面
      me.showShop = false;
      me.showAllGoods = false;
      me.showOneGoods = true;
      me.nowOneGood = me.recommendGoodsList[index];
      me.preImgages = me.nowOneGood.thumbs.map((item) => {
        return item.path_url;
      });
      me.searchUserHasSaveGoods(me.nowOneGood.id);
    },
    saveAreaOnly(obj) {
      //收藏宝贝进入单个页面
      me.showShop = false;
      me.showAllGoods = false;
      me.showOneGoods = true;
      me.nowOneGood = obj;
      me.preImgages = me.nowOneGood.thumbs.map((item) => {
        return item.path_url;
      });
      me.searchUserHasSaveGoods(me.nowOneGood.id);
    },
    searchUserHasSaveGoods(goodId) {
      //查询用户当前是否收藏该商品
      getData("/shop/is-remark", { good_id: goodId }).then((res) => {
        if (res.code == "0") {
          if (res.code == 0) {
            if (res.data.is_remark == 0) {
              me.hasSaveGood = false;
            } else {
              me.hasSaveGood = true;
            }
          }
        }
      });
    },
    searchTopGoods(shopId) {
      //查询店铺内推荐的商品
      getData("/shop/recommend-goods", { shop_id: me.shopId }).then((res) => {
        if (res.code == "0") {
          me.recommendGoodsList = res.data;
        }
      });
    },
    getShopInfo() {
      //根据id查询店铺信息
      getData("/shop", { shop_id: me.shopId }).then((res) => {
        if (res.code == "0") {
          me.shopInfo = res.data;
          me.showCard = true;
          me.$nextTick(function () {
            me.getBase64Image(me.shopInfo.small_logo_url);
          });
          me.getShare(); //xhy:05.23
          me.smallImages = res.data.thumbs.map((item) => {
            return item.small_path_url;
          });
          me.images = res.data.thumbs.map((item) => {
            return item.path_url;
          });
          if (res.data.is_remark == 1) {
            me.hasGuanzhu = true;
          }
        }
      });
    },
    getShopGoodsList() {
      //根据id查询店铺的分类列表
      getData("/shop/keywords", { shop_id: me.shopId }).then((res) => {
        if (res.code == "0") {
          me.shopCategoryList = res.data;
        }
      });
    },
    searchGoodsByCategory(categoryId) {
      //根据分类id查询店铺商品
      me.nowCategoryId = categoryId;
      getData("/shop/goods", {
        shop_id: me.shopId,
        category: categoryId,
        page: 1,
      }).then((res) => {
        if (res.code == "0") {
          me.goodsList = res.data;
        }
      });
    },
    searchGoodsByKeywords() {
      //根据关键字查询宝贝信息
      if (!me.shopGoods) {
        this.$toast("关键字不能为空");
        return;
      }
      getData("/shop/search-good", {
        shop_id: me.shopId,
        keyword: me.shopGoods,
        page: 1,
      }).then((res) => {
        if (res.code == "0") {
          me.goodsList = res.data;
          me.showShop = false;
          me.showAllGoods = true;
          me.showOneGoods = false;
        }
      });
    },
    guanzhuShop() {
      //关注店铺
      if (localStorage.getItem("token") == null) {
        this.$toast("请先登录！");
        return false;
      }
      let formData = new FormData();
      formData.append("shop_id", me.shopId);
      formData.append("action", "1");
      postData("/user/like/remark-shop", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          token:
            localStorage.getItem("token") != ""
              ? localStorage.getItem("token")
              : "123456",
        },
      })
        .then((res) => {
          if (res.code == 0) {
            me.hasGuanzhu = true;
          }
        })
        .catch((err) => {
          this.$toast("关注失败");
        });
    },
    saveGoods() {
      //收藏宝贝信息
      if (localStorage.getItem("token") == null) {
        this.$toast("请先登录！");
        return;
      }
      let formData = new FormData();
      formData.append("good_id", me.nowOneGood.id);
      formData.append("action", "1");
      postData("/user/like/remark-good", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          token:
            localStorage.getItem("token") != ""
              ? localStorage.getItem("token")
              : "123456",
        },
      })
        .then((res) => {
 
          if (res.code == 0) {
            me.hasSaveGood = true;
          }
        })
        .catch((err) => {
          this.$toast("关注失败");
        });
    },
    removeGuanzhu() {
      //取消关注
      if (localStorage.getItem("token") == null) {
        this.$toast("请先登录！");
        return;
      }
      let formData = new FormData();
      formData.append("shop_id", me.shopId);
      formData.append("action", "0");
      postData("/user/like/remark-shop", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          token:
            localStorage.getItem("token") != ""
              ? localStorage.getItem("token")
              : "123456",
        },
      })
        .then((res) => {
          if (res.code == 0) {
            me.hasGuanzhu = false;
          }
        })
        .catch((err) => {
          this.$toast("取消失败");
        });
    },
    removeSave() {
      //取消收藏
      if (localStorage.getItem("token") == null) {
        this.$toast("请先登录！");
        return;
      }
      let formData = new FormData();
      formData.append("good_id", me.nowOneGood.id);
      formData.append("action", "0");
      postData("/user/like/remark-good", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          token:
            localStorage.getItem("token") != ""
              ? localStorage.getItem("token")
              : "123456",
        },
      })
        .then((res) => {
          if (res.code == 0) {
            me.hasSaveGood = false;
          }
        })
        .catch((err) => {
          this.$toast("关注失败");
        });
    },
    getShare() {
      //获取配置数据
      let pathname = encodeURIComponent(window.location.pathname);
      let search = encodeURIComponent(window.location.search);
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      var iPad = u.indexOf("iPad") > -1;
      var iPhone = u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1;
      let anURL =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        window.location.search; //安卓地址
      let iosURL = this.$store.state.jumpUrl; //ios地址
      let result = "";
      if (isAndroid) {
        result = anURL;
      }
      if (isiOS || iPad || iPhone) {
        result = window.location.href;
      }
      //this.message=result;
      result = encodeURIComponent(result);
      getData("/oauth/credential/jssdk?debug=1&url=" + result).then((res) => {
        wx.config({
          //debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.noncestr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见附录1
          jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表，所有JS接口列表见微信公众平台附录
        });
        wx.ready(function () {
          wx.updateAppMessageShareData({
            title: me.shopInfo.name, // 分享标题
            desc: '家纺城公众圈——家纺人每天都在用的线上广告平台！', // 分享描述
            link:
              'http://jfc.jfbst.com/shopDetailInfo?type=' +
              me.type +
              '&id=' +
              me.shopId,
            imgUrl: me.shopInfo.logo_url, // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
              // store.commit("controlStatusUserPage/showMsg", "分享成功");
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              // store.commit("controlStatusUserPage/showMsg", "您取消了操作");
            },
          });
          wx.updateTimelineShareData({
            title: me.shopInfo.name, // 分享标题
            link:
              'http://jfc.jfbst.com/shopDetailInfo?type=' +
              me.type +
              '&id=' +
              me.shopId,
            imgUrl: me.shopInfo.logo_url, // 分享图标
            success: function (res) {},
            cancel: function () {},
          });
        });
      });
    },
  },
  mounted() {
    me = this;
    me.type = this.$route.query.type;
    me.shopId = me.$route.query.id;
    me.codeText =
      "http://jfc.jfbst.com/shopDetailInfo?type=info&id=" + me.$route.query.id;
    me.getShopInfo();
    me.getShopGoodsList();
    me.searchTopGoods();
    me.getshopAct();
    if (me.$route.query.type == "info") {
      me.showShop = true;
      me.showAllGoods = false;
      me.showOneGoods = false;
    } else if (me.$route.query.type == "goods") {
      me.showShop = false;
      me.showAllGoods = true;
      me.showOneGoods = false;
      me.searchGoodsByCategory(0);
    }
    if (me.$route.query.obj) {
      me.saveAreaOnly( JSON.parse(me.$route.query.obj));
    }
  },
  destroyed() {
    me.closeImg();
  },
};
</script>
<style scoped>
@import "../assets/styles/style.css";
.btmImage div {
  flex-grow: 0;
  width: 33.5px;
  height: 33.5px;
  margin-top: 5.5px;
  margin-right: 5.5px;
  overflow: hidden;
  position: relative;
}

.btmImage img {
  width: auto !important;
  position: absolute;
  max-width: 33.5px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.bg {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: black;
  opacity: 0.5;
}
.saveHB {
  background-color: #f0d3df;
  border-radius: 15px;
  color: #fff;
  width: 100px;
  display: flex;
  justify-content: center;
  line-height: 30px;
  border: 1px solid gray;
  height: 30px;
  margin-left: 50%;
  margin-top: 10px;
  transform: translateX(-50%);
}
.bottom {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-size: 12px;
  color: gray;
}
.baseSale {
  font-size: 12px;
  color: gray;
  margin-top: 15px;
}
.baseSale > div:nth-child(2) {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.infoBack {
  width: 100%;
}
.infoItem {
  color: gray;
  display: flex;
  margin-bottom: 8px;
}
.infoItem > div:nth-child(1) {
  justify-content: flex-end;
  display: flex;
  margin-right: 10px;
  width: 20%;
}
.infoItem > div:nth-child(2) {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 60%;
  text-align: left;
  margin-left: 10px;
  margin-top: -1px;
  font-size: 12px;
  line-height: 16px;
}
.infoItem img {
  width: 13px;
  height: 13px;
}
.shopNames {
  font-size: 13px;
  color: gray;
  margin-top: 3px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.hbShopInfo {
  width: 100%;
  display: flex;
  justify-content: center;
}
.hbShopInfo img {
  width: 50px;
  height: 50px;
}
.haibao2 {
  position: fixed;
  width: 250px;
  height: 393px;
  border: 1px solid #eee;
  background-color: #fff;
  top: 10000000px;
  left: 0px;
}
.haibao {
  position: fixed;
  width: 250px;
  height: 393px;
  border: 1px solid #eee;
  background-color: #fff;
  top: 0px;
  left: 0px;
  bottom: 120px;
  right: 0px;
  margin: auto;
}
.hbheadImg {
  height: 74px;
}
.hbheadImg img {
  height: 100%;
}
.eCard img {
  width: 60px;
  text-align: left;
}
.shopImages {
  margin: 37px 30px 30px 30px;
}
.shopImg {
  margin-top: 10.5px;
  display: flex;
  width: 329px;
  flex-wrap: wrap;
}
.shopImg > div {
  width: 106px;
  height: 106px;
  margin-right: 3px;
  margin-top: 2px;
}
.shopImg img {
  width: 100%;
  height: 100%;
}
.simpleInfo,
.shopAct {
  margin: 30px;
}
.simpleInfo > div:nth-child(1),
.shopImages > div:nth-child(1),
.shopAct > div:nth-child(1) {
  text-align: left;
  font-size: 16px;
  color: #4d4d4d;
  font-weight: bold;
}
.simpleInfo > div:nth-child(2) {
  margin-top: 9px;
  font-size: 14px;
  color: #4d4d4d;
  text-align: left;
}
.shopCode {
  color: #892885;
  width: 100%;
  display: inline-block;
  text-align: center;
  background-color: #fff;
  padding-top: 7px;
  font-size: 14px;
  padding-bottom: 7px;
}
.basicInfo {
  background-color: #fff;
  width: 100%;
}
.basicInfo > div {
  display: flex;
  padding-top: 7px;
  padding-bottom: 7px;
  font-size: 14px;
  border-bottom: 1px solid #e6e6e6;
}
.basicInfo > div > div:nth-child(1) {
  padding-left: 10%;
  color: #b3b3b3;
  text-align: left;
  width: 100px;
}
.basicInfo > div > div:nth-child(2) {
  text-align: left;
  color: #4d4d4d;
  width: 250px;
}
.recomdeList {
  display: flex;
  margin-top: 10px;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
}
.recomdeList > div {
  margin-left: 5px;
}
.goodsRecom {
  width: calc(100%-24px);
  margin-top: 28px;
  text-align: left;
  padding-left: 24px;
  padding-bottom: 5px;
  font-size: 14px;
  color: #892785;
  font-weight: bold;
  border-bottom: 1.5px solid #d3d3d3;
}
.goodsImages {
  margin-top: 20px;
  margin-left: 37px;
  display: flex;
  width: 300px;
  flex-wrap: wrap;
}
.goodsImages > div {
  width: 95px;
  height: 95px;
  margin-bottom: 4px;
  margin-left: 3px;
}
.goodsImages img {
  width: 100%;
  height: 100%;
}
.goodsDetailInfo {
  color: #666666;
  font-size: 15px;
  margin-top: 23px;
  margin-left: 41px;
  width: 285px;
}
.headInfo {
  width: 100%;
  height: 95px;
  background-image: url(../assets/images/images/shopBG.png);
  position: absolute;
  top: 0;
  left: 0;
}
.inputBox {
  opacity: 0.8;
  width: 337px;
  height: 26.5px;
  background-color: #fff;
  border-radius: 5px;
  margin-top: 5px;
  margin-left: 19px;
  display: flex;
  align-items: center;
}
.inputstyle {
  display: flex;
  align-items: center;
  margin-left: 12.5px;
  flex-grow: 1;
  height: 100%;
}
.inputstyle input {
  border: none;
  padding: 0;
  margin: 0;
  font-size: 12px;
  height: 100%;
  flex-grow: 1;
}
.searchBox {
  width: 50px;
  flex-shrink: 0;
  height: 80%;
  border-left: 1px solid gray;
}
.searchBox img {
  width: 20px;
  height: 20px;
}
.shopBasicInfo {
  width: 337px;
  margin-left: 19px;
  margin-top: 11px;
  display: flex;
}
.shopBasicInfoLeft {
  flex-grow: 1;
  display: flex;
  justify-content: flex-start;
}
.shopBasicInfoLeft > div {
  display: flex;
}
.shopBasicInfoRight {
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.shopBasicInfoRight > div {
  display: flex;
}
.headImg {
  width: 38px;
  height: 38px;
}
.headImg img {
  width: 100%;
  height: 100%;
}
.shopName > div:nth-child(1) {
  color: #fff;
  font-size: 15px;
  margin-left: 9px;
}
.shopName > div:nth-child(2) {
  color: #fff;
  font-size: 8px;
  margin-left: 9px;
  margin-top: 1.5px;
}
.attaImg {
  width: 15px;
  height: 15px;
}
.attaBox {
  color: #fff;
  font-size: 15px;
  padding: 0 5px;
  height: 18.5px;
  border: 1px solid #fff;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.chooseBtn {
  margin-top: 95px;
  width: 100%;
  height: 38px;
  display: flex;
  background-color: #e6e6e6;
  font-size: 14px;
}
.chooseBtn > div {
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
}
.closeTc {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.chooseBtn > div:nth-child(1) {
  border-right: 1px solid #fff;
}
.active {
  color: #892785;
}
.noactive {
  color: #4d4d4d;
}
.saveGoods {
  width: 100%;
  height: 38px;
  display: flex;
  background-color: #fff;
}
.saveGoods > div {
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
}
.phoneCall {
  width: 21px;
  height: 21px;
}
.phoneCall img {
  width: 100%;
  height: 100%;
}
.saveGood {
  margin-left: 15.5px;
  width: 83px;
  height: 23px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #892785;
  font-size: 14px;
  border: 1px solid #892785;
  border-radius: 5px;
  font-weight: bold;
}
.saveGood > div:nth-child(1) {
  width: 15.5px;
  height: 14px;
  margin-right: 4px;
}
.goodsContent {
  margin-top: 1px;
  background-color: #f2f2f2;
  display: flex;
  margin-bottom: 71px;
}
.contentLeft {
  width: 92.5px;
}
.activeList {
  color: #892785;
  border-left: 2px solid #892785;
  padding-top: 9px;
  padding-bottom: 9px;
  font-size: 14px;
  background-color: #e6e6e6;
  padding-left: 9px;
  padding-right: 9px;
  word-break: break-all;
}
.noactiveList {
  word-break: break-all;
  color: #4d4d4d;
  font-size: 12px;
  padding-top: 9px;
  padding-bottom: 9px;
  background-color: #fff;
  padding-left: 9px;
  padding-right: 9px;
  border-bottom: 1px solid #e9e9e9;
}
.contentRight {
  height: fit-content;
  margin-top: 11px;
  width: 283px;
  display: flex;
  flex-wrap: wrap;
}
.actItem {
  margin-top: 10px;
  padding: 5px;
  border-bottom: 1px solid #d3d3d3;
}
.actItem > div:nth-child(1) {
  font-size: 14px;
  color: #4d4d4d;
  text-align: left;
}
.actItem > div:nth-child(2) {
  display: flex;
  margin-top: 10px;
}
.actItem > div:nth-child(2) div {
  flex-grow: 1;
  font-size: 11px;
  color: #8f8f8f;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.actItem > div:nth-child(2) div:nth-child(1) {
  display: flex;
  justify-content: flex-start;
}
.actItem > div:nth-child(2) div:nth-child(2) {
  display: flex;
  justify-content: flex-end;
}
</style>